var map = {
  "./cs.json": [
    "gUR",
    [
      "ue"
    ]
  ],
  "./en.json": [
    "qYf",
    [
      "oqi"
    ]
  ],
  "./pl.json": [
    "YM8",
    [
      69
    ]
  ],
  "./ru.json": [
    "nr",
    [
      "py"
    ]
  ],
  "./tr.json": [
    "EB",
    [
      "a0"
    ]
  ],
  "./ja.json": [
    "O4",
    [
      "0q"
    ]
  ],
  "./zh.json": [
    "EH",
    [
      "ym"
    ]
  ],
  "./pt-br.json": [
    "Zs",
    [
      "vj"
    ]
  ],
  "./de.json": [
    "WG",
    [
      "wo"
    ]
  ],
  "./es.json": [
    "z2q",
    [
      "5z4"
    ]
  ],
  "./fr.json": [
    "b3k",
    [
      "h"
    ]
  ],
  "./it.json": [
    "jE",
    [
      "d7"
    ]
  ],
  "./ko.json": [
    "U0",
    [
      "a5"
    ]
  ],
  "./pt.json": [
    "DR8",
    [
      "p4"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "v9";
module.exports = __rspack_async_context;
